var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEmail = function SvgEmail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.875 5H4.125C3.82663 5 3.54048 5.12292 3.3295 5.34171C3.11853 5.5605 3 5.85725 3 6.16667V17.8333C3 18.1428 3.11853 18.4395 3.3295 18.6583C3.54048 18.8771 3.82663 19 4.125 19H19.875C20.1734 19 20.4595 18.8771 20.6705 18.6583C20.8815 18.4395 21 18.1428 21 17.8333V6.16667C21 5.85725 20.8815 5.5605 20.6705 5.34171C20.4595 5.12292 20.1734 5 19.875 5ZM19.0087 17.8333H5.05875L8.99625 13.61L8.18625 12.7992L4.125 17.1567V7.05333L11.1169 14.2692C11.3277 14.4865 11.6128 14.6084 11.91 14.6084C12.2072 14.6084 12.4923 14.4865 12.7031 14.2692L19.875 6.8725V17.0808L15.735 12.7875L14.9419 13.61L19.0087 17.8333ZM4.86187 6.16667H18.9637L11.91 13.4408L4.86187 6.16667Z",
    fill: "currentColor"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/email.fbf91d76.svg";
export { ForwardRef as ReactComponent };